import axios from "axios";

const AuthAxios = axios.create({
    baseURL: import.meta.env.VITE_AUTHORITY,
    ...(import.meta.env.DEV && {
        // headers: { 'ngrok-skip-browser-warning': 'true' },
    }),
});

export { AuthAxios };